import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
export const ErrorMessage = styled.div `
    margin-top: ${(props) => (props.isMobile ? "3px" : "8px")};
    margin-left: 14px; // matches MUI helper text
    font-size: ${fontSizes.TINY};
    color: ${colors.tulip_main};
    line-height: normal;
    letter-spacing: 0.4px;
`;
